(ns superadmin.os-workspace-editor.create-ocp.db
  (:require [clojure.spec.alpha :as spec]
            [clojure.string :as str]
            [common.form.core :as form]
            [common.url-template :as url-tpl]
            [common.validators.core :refer [valid-email?]]
            [phrase.alpha :as p]
            [re-frame.core :as rf]))

(def entity-name "Mapping")

;;
;; Validation
;;

(defn only-digits? [value]
  (boolean (re-matches #"^\d+$" value)))

(defn uuid-as-lowercase-string? [value]
  (boolean (re-matches #"^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$" value)))

(spec/def ::workspace-id
  (spec/and string?
            (complement str/blank?)
            uuid-as-lowercase-string?))

(spec/def ::agency-id
  (spec/and string?
            (complement str/blank?)
            only-digits?))

(spec/def ::advertiser-id
  (spec/and string?
            (complement str/blank?)
            only-digits?))

(spec/def ::email
  (spec/and string?
            valid-email?))

(spec/def ::value
  (spec/keys :req-un [::workspace-id ::agency-id ::advertiser-id]
             :opt-un [::email]))

(p/defphraser string? [_ problem key]
  {:message "The field should be a string"
   :in (:in problem)
   :problem problem})

(p/defphraser (complement str/blank?) [_ problem]
  {:message "The field should not be empty"
   :in (:in problem)
   :problem problem})

(p/defphraser only-digits? [_ problem key]
  {:message "The field should contains numbers only"
   :in (:in problem)
   :problem problem})

(p/defphraser uuid-as-lowercase-string? [_ problem key]
  {:message "The field should be a lowercase UUID"
   :in (:in problem)
   :problem problem})

(p/defphraser valid-email? [_ problem key]
  {:message "The email should be valid"
   :in (:in problem)
   :problem problem})

(def validate-form
  (rf/enrich
   (form/get-validate-form-fn :form.os-workspace-editor.create ::value)))

(form/register-form {:namespace :form.os-workspace-editor.create
                     :initial-value {}
                     :validate-form validate-form
                     :submit-event :form.os-workspace-editor.create/submit-form})

(rf/reg-sub :form.os-workspace-editor.create/email-is-not-empty-and-valid
  (fn [db]
    (let [form-value (get-in db [:form.os-workspace-editor.create :value])
          email (:email form-value)]
      (and (boolean email) (valid-email? email)))))

;;
;; Form
;;

(rf/reg-event-fx :form.os-workspace-editor.create/init-form
  (fn [_ _]
    {:fx [[:dispatch [:form.os-workspace-editor.create/init]]]}))

(rf/reg-event-fx :form.os-workspace-editor.create/submit-form
  (fn [_ [_ v]]
    (let [v' (-> v
                 (update :agency-id js/parseInt)
                 (update :advertiser-id js/parseInt))]
      {:fx [[:dispatch [:loader/open]]
            [:dispatch [::create-mapping v']]]})))

(def use-bind-control (partial form/use-bind-control :form.os-workspace-editor.create))
(def use-error-message (partial form/use-error-message :form.os-workspace-editor.create))

;;
;; Backend
;;

(rf/reg-event-fx ::create-mapping
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context :resource.user/token]} [_ params]]
    {:db db
     :http {:method :post
            :params params
            :uri (url-tpl/render :api/os-workspace-mapping url-context)
            :headers {"Authorization" token}
            :on-success [::create-mapping-success]
            :on-failure [::create-mapping-failure]}}))

(rf/reg-event-fx ::create-mapping-success
  (fn [_ _]
    {:fx [[:dispatch [:ocp/close]]
          [:dispatch [:loader/close]]
          [:invalidate-queries {:queryKey ["workspace-mappings"]}]
          [:dispatch [:response-handler/handle-response
                      {:entity-name entity-name
                       :type :success
                       :message "Successfully created mapping"}]]]}))

(rf/reg-event-fx ::create-mapping-failure
  (fn [_ [event response]]
    (let [message (-> response :error :message (or "Failed to create mapping"))]
      {:fx [[:dispatch [:ocp/close]]
            [:dispatch [:loader/close]]
            [:dispatch [:response-handler/handle-response
                        {:entity-name entity-name
                         :type :error
                         :event event
                         :message message
                         :response response}]]]})))
